import { render, staticRenderFns } from "./UtilsContent.vue?vue&type=template&id=3b89a459&"
import script from "./UtilsContent.vue?vue&type=script&lang=js&"
export * from "./UtilsContent.vue?vue&type=script&lang=js&"
import style0 from "./UtilsContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports